export default {

  SysMenu: {
    /**
     * 工单查询菜单ID
     */
     ORDER_M_ID: 19,
   /**
    * 合同订单
    */
    CONTRACT_M_ID: 16,
    /**
    * 合同回款
    */
    RETURN_M_ID: 21,
    /**
    * 合同退款
    */
    REFUND_M_ID: 31,
     /**
     * 发票查询
     */
     INVOICE_M_ID: 29,
    /**
    * 合同应收
    */
    COLLECT_M_ID: 22,
   /**
    * 客户查询
    */
    CUSTOMER_M_ID: 11,
    /**
    * 客户跟进
    */
     CUSTOMER_FOLLOW_M_ID: 48,
   /**
    * 客户联系人查询
    */
    CUSTOMER_CONTACTS_M_ID: 12,
    /**
     * 个人公海
     */
    CUSTOMER_SCREENING_M_ID: 33,
   /**
    * 非定向公海
    */
    CUSTOMER_SCREENING_POOL_M_ID: 35,
    /**
    * 我的审核
    */
    MY_AYDIT_RECORD_M_ID: 41,
    /**
   * 新增用户考核统计
   */
    CUSTOMER_NEWSTATIS_M_ID: 42,
  /**
   * 专利查询
   */
    PARTENT_LIST_M_ID: 50,
    /**
    * 专利缴费
    */
    PARTENT_PAY_LIST_M_ID: 60,
    /**
     * 客户绑定
     */
    CUSTOMER_BIND_M_ID: 62,
    /**
    * 软著
    */
    SOFT_LIST_M_ID: 66,
    /**
    * 提成结算
    */
    SETTLE_COMMISSION_M_ID: 70,
    /**
     * 通知公告
     */
    NOTICE_M_ID: 77,
    /**
    * 通话记录
    */
    CALL_RECORD_M_ID: 79,
     /**
     * 居间费查询
     */
     MEDIATOR_M_ID: 94,
     /**
     * 其他费查询
     */
     OTHER_M_ID: 95,
  },
  // 合同状态
  contractStatePid: 116,
  ContractState: {
    /**
    * 合同已签订
    */
    SIGN_ID: 117,
    /**
    * 未通过
    */
    UN_PASS_ID: 120,
    /**
    * 中/终止
    */
    STOP_ID: 118,
    /**
    * 通过
    */
    PASS_ID: 237,
     /**
    * 中/终止 审核中
    */
     STOP_AUDIT_ID: 560
  },
  // 回款状态（回款单）
  returnedMoneyStatePid: 153,
  ReturnedMoneyState: {
    /**
    * 未收款
    */
    UN_GET_MONEY_ID: 154,
    /**
    * 已收款
    */
    GET_MONEY_ID: 155,
  },
  contractTypePid: 111, // 合同类型
  contractType: {
    /**
     * 直销空白合同（空白-客户已付款，合同未签）
     */
    NO_CONTRACT: 113
  },
  // 客户阶段（回款单）
  customerStagePid: 47, // 客户阶段,
  CustomerState: {
    /**
    * 需求
    */
    NEED_ID: 48,
    /**
    * 成交
    */
    DEAL_ID: 49,
  },
  customerFollowTypePid: 76, // 跟进方式
  CustomerFollowType: {
    /**
     * 外出
     */
    OUT_ID: 77,
    /**
     * 电话
     */
    CALL_ID: 78
  },
  ProductType: {
    /**
     * 著作权IDS
     */
    ZhuZuoQuan: [67, 68, 69, 70, 71, 72, 73, 143, 176, 177, 255, 262, 263],
    /**
     * 发明专利
     */
    FaMingZhuanLi: [59, 60, 61, 62, 63, 64, 65, 66, 144, 147, 148, 201, 208, 209, 211, 224, 225, 226, 229, 245, 246, 261, 277, 278],
     /**
     * 商标专利
     */
    ShangBiao: [57, 58, 171],
    /**
     * 高新代理记账
     */
    Bookkeeping: [102, 103, 104],
    /**
     * 审计报告
     */
    AuditReport: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 152, 153, 154, 155, 165, 191, 192, 193],
    /**
     * 高新
     */
    HighTech: [22, 24, 25],
    /**
     * 研发后补助
     */
    RDSubsidy: [33, 34, 35],
    /**
     * 项目类别，2、3类
     */
    TypeTwoThree: [95, 96],
    /**
     * 五类
     */
    TypeFive: [559]
  },

  // 数据字典父级ID
  bankAccountPid: 157, // 账户
  orderUsersPid: 171, // 工单用户
  orderStepPid: 256, // 工单步骤
  orderUrgentLevelPid: 177, // 工单紧急程度
  patentPurposesPid: 181, // 知识产权用途
  dataSetPid: 192, // 数据权限
  invoiceTypePid: 231, // 发票类型
  invoiceMoneyTypePid: 197, // 发票金额内容
  invoiceReceiveTypePid: 238, // 发票领取方式
  policyTypePid: 332, // 政策来源

  /**
   * 流程
   */
  contactsOrderFollowTypePids: 144, // 流程类型
  contactsOrderFollowTypeId: 145, // 流程类型（合同订单）
  contactsReturnedTypeId: 191, // 流程类型（回款单)
  contactsInvoiceTypeId: 202, // 流程类型（发票)
  contactsRefundTypeId: 146, // 流程类型（退款)
  outFollowTypeId: 286, // 流程类型（外出)
  patentPayFollowTypeId: 330, // 流程类型（专利付费)
  customerBindFollowTypeId: 345, // 流程类型（客户绑定)，
  patentWritrAuditTypeId: 291, // 流程类型（客户绑定)
  trademarkPayAuditTypeId: 500, // 流程类型（商标付费)
  ruZhiAuditTypeId: 524, // 流程类型（入职)
  formalAuditTypeId: 526, // 流程类型（转正)
  repairAuditTypeId: 529, // 流程类型（补卡)
  mediatorTypeId: 540, // 流程类型（居间费)
  mediatorBackTypeId: 554, // 流程类型（居间费)退还
  otherTypeId: 541, // 流程类型（其他费用)
  patentSaleTypeId: 558, // 流程类型 (专利出售审批)
  contactsStopFollowTypeId: 561, // 流程类型 (合同终止审批)
  /**
   * 业务
   */
  customerStatusPid: 23, // 客户状态/类型
  customerExtentPid: 30, // 客户重要程度
  customerBackPid: 36, // 客户退回设置类型
  customerSeniorityPid: 292, // 客户资质
  bankAccountTypePid: 40, // 账户类型
  customerTypePid: 51, // 客户类型
  customerNaturePid: 55, // 客户性质
  customerLevelPid: 59, // 客户分级 （废弃）
  customerGradesPid: 549, // 客户分级
  customerTradePid: 63, // 客户行业
  qccCustomerTradePid: 346, // 客户行业(企查查)
  customerFromPid: 66, // 客户来源
  customerDegreePid: 70, // 客户重要程度
  customerFollowStagePid: 47, // 跟进阶段
  productTypePid: 84, // 产品分类
  productStatePid: 93, // 产品类别
  contractSignPid: 98, // 合同签订单位
  contractValidPid: 106, // 合同有效期
  userLevelPid: 122, // 人员级别
  contractPayTypePid: 129, // 合同付款方式
  contractBackTypePid: 135, // 合同回款类型
  contractBackStatePid: 138, // 合同回款状态
  returnedMoneyTypePid: 147, // 回款类型（回款单）
  returnedMoneyPayTypePid: 161, // 支付方式（回款单）
  contractRefundTypePid: 219, // 合同退款类型
  screeningStatePid: 224, // 客户状态(筛选池)
  screeningState227Id: 227, // 客户状态(筛选池)已入库
  screeningState230Id: 230, // 客户状态(筛选池)已导入
  settleChannelPid: 326, // 结算渠道(软著)
  agentBookkeepingServicePid: 457, // 代理记账附加服务
  specialTypePid: 461, // 专审类型
  auditSettleChannelPid: 465, // 结算渠道(审计)
  highTechRDSubsidyPid: 484, // 附加服务
  TrademarkTypePid: 491, // 商标类型
  TrademarkAgencyPid: 497, // 商标代理机构
  educationPid: 501, // 学历
  politicaPid: 506, // 政治面貌
  dutiesPid: 511, // 职位类型
  penaltyTypePid: 520 // 乐捐类型
}
